import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Game_Login.css';
import { initializeApp, getApps } from "firebase/app";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: "dashboard-c2d5d",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0]; // Use the already initialized app
}

// Initialize Firebase Authentication
const auth = getAuth(app);

const Game_Login = ({ onLogin }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // List of allowed usernames
  const allowedUsernames = [
    'saumya.shah@gitcoatings.com',
    'michael.jacot@gitcoatings.com',
    'ryan.ingham@gitcoatings.com',
    'marciel.gaier@gitcoatings.com',
    // Add more allowed usernames here
  ];

  const toggleForm = () => {
    setIsLogin(!isLogin);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if the entered email is in the list of allowed usernames
    if (!allowedUsernames.includes(email)) {
      setError('This email is not authorized to access this page.');
      return;
    }

    try {
      // If the email is allowed, proceed with Firebase authentication
      if (isLogin) {
        await signInWithEmailAndPassword(auth, email, password);
      } else {
        setError('Registration is not allowed on this page.');
        return;
      }
      onLogin(); // Update the login state in App.js
      navigate('/fire'); // Redirect to the Visualization page
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="gaming-login-page">
      <div className="infinite-container">
        <div className="black-sun"></div> {/* This is the black sun */}
        <div className="fire-animation"></div> {/* This is the fire animation */}
        <div className="login-box">
          <h4>{isLogin ? 'Welcome to Vessel Analysis Warehouse' : 'Sign Up'}</h4>
          <form onSubmit={handleSubmit}>
            {!isLogin && (
              <div className="input-group">
                <label>Username</label>
                <input
                  type="text"
                  placeholder="Enter your username"
                  required
                />
              </div>
            )}
            <div className="input-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="input-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <button type="submit" className="btn">
              {isLogin ? 'Login' : 'Sign Up'}
            </button>
          </form>
          <div className="toggle-link">
            <p>
              {isLogin ? "Don't have an account?" : 'Already have an account?'}{' '}
              <span onClick={toggleForm}>{isLogin ? 'Sign Up' : 'Login'}</span>
            </p>
          </div>
        </div>
      </div>
      <div className="infinite-background"></div>
    </div>
  );
};

export default Game_Login;
